import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseResponse } from '../../models/commonResponse';
import { Observable } from 'rxjs';
import { calculateHashForRequest } from '../../pages/shared/share-function';

@Injectable({
  providedIn: 'root'
})
export class CashoutManagementService {

  httpOptions = {
      headers: new HttpHeaders({
        'Content-typ': 'application/json',
      })
    }
  baseAPIUrl = environment.baseAPIUrl+ "/" + environment.apiVer;

  mobileAPIUrl = environment.mobileAPIUrl+ "/" + environment.apiVer;
  

  constructor(private http: HttpClient) { 
    
  }

  getTransactionList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/transaction`, msgData, this.httpOptions);
  }

  transactionDetail(msgData: any){
    return this.http.post(this.baseAPIUrl + `pensioncashout/cashoutdetail`, msgData, this.httpOptions);
  }

  getPdReportTransactionList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/lastcashouttransaction`, msgData, this.httpOptions);
  }


  downloadQR(msgData: any){
    return this.http.post(this.mobileAPIUrl + `qr/generateagentqr`, msgData, this.httpOptions);
  }

  getReconciliationList(msgData: any, tokenAuth: any, requestId: string){
    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-Skip-Auth': 'true',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': "cd52f084-e1d1-4d19-94bc-8d781fa51f01",
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    const copyForHash:any = { ...msgData }; 
    const toPassAPI:any = { ...msgData };
    const hashValue: any = calculateHashForRequest(copyForHash);
    toPassAPI["HashValue"] = hashValue;
    console.log('toPassAPI', toPassAPI)
    
    return this.http.post<BaseResponse<any>>(this.mobileAPIUrl + `agents/reconciliationreport `, toPassAPI, httpOptions);
  }

  getAgentTransactionList(msgData: any, tokenAuth: any, requestId: string){
    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-Skip-Auth': 'true',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': "cd52f084-e1d1-4d19-94bc-8d781fa51f01",
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    const copyForHash:any = { ...msgData }; 
    const toPassAPI:any = { ...msgData };
    const hashValue: any = calculateHashForRequest(copyForHash);
    toPassAPI["HashValue"] = hashValue;
    console.log('toPassAPI', toPassAPI)
    
    return this.http.post<BaseResponse<any>>(this.mobileAPIUrl + `transfer/agenttransactionlist `, toPassAPI, httpOptions);
  }

  getFundTransactionList(msgData: any, tokenAuth: any, requestId: string){
    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-Skip-Auth': 'true',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': "cd52f084-e1d1-4d19-94bc-8d781fa51f01",
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    const copyForHash:any = { ...msgData }; 
    const toPassAPI:any = { ...msgData };
    const hashValue: any = calculateHashForRequest(copyForHash);
    toPassAPI["HashValue"] = hashValue;
    console.log('toPassAPI', toPassAPI)
    
    return this.http.post<BaseResponse<any>>(this.mobileAPIUrl + `agents/fundoutlist`, toPassAPI, httpOptions);
  }

  fundOutSettle(msgData: any, tokenAuth: any, requestId: string){
    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-Skip-Auth': 'true',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': "cd52f084-e1d1-4d19-94bc-8d781fa51f01",
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    const copyForHash:any = { ...msgData }; 
    const toPassAPI:any = { ...msgData };
    const hashValue: any = calculateHashForRequest(copyForHash);
    toPassAPI["HashValue"] = hashValue;
    console.log('toPassAPI', toPassAPI)
    
    return this.http.post<BaseResponse<any>>(this.mobileAPIUrl + `fundout/fundoutsettle`, toPassAPI, httpOptions);
  }

  fundOutReverse(msgData: any, tokenAuth: any, requestId: string){
    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-Skip-Auth': 'true',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': "cd52f084-e1d1-4d19-94bc-8d781fa51f01",
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    const copyForHash:any = { ...msgData }; 
    const toPassAPI:any = { ...msgData };
    const hashValue: any = calculateHashForRequest(copyForHash);
    toPassAPI["HashValue"] = hashValue;
    console.log('toPassAPI', toPassAPI)
    
    return this.http.post<BaseResponse<any>>(this.mobileAPIUrl + `fundout/fundoutsettlereverse`, toPassAPI, httpOptions);
  }

  inquirySearch(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/inquiry`, msgData, this.httpOptions);
  }

  searchCashoutUser(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/searchcashoutuser`, msgData, this.httpOptions);
  }

  nomineeInfoDetailCashout(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/getnomineeinfoforcashout`, msgData, this.httpOptions);
  }

  getPensionTypeDataApi(){
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + `pensions/pensiontype`, this.httpOptions);
  }

  retryLiveness(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `recognition/livenessvideovalidation`, msgData, this.httpOptions);
  }

  livenessDetect(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `recognition/livenessdetector`, msgData, this.httpOptions);
  }

  livenessValidation(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `recognition/livenessvalidation`, msgData, this.httpOptions);
  }

  requestOtp(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/requestotp`, msgData, this.httpOptions);
  }

  verifyOtp(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/verifyOTP`, msgData, this.httpOptions);
  }

  pensionCashout(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/cashout`, msgData, this.httpOptions);
  }
  
  pensionCashoutDownloadSampleFile(): Observable<Blob> {
    return this.http.get(this.baseAPIUrl + 'pensioncashout/downloadsamplefile', { responseType: 'blob' });
  }

  uploadPaymentStatusFile(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioncashout/updatepaymentstatus`, msgData, this.httpOptions);
  }

  cashRequestList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/list`, msgData, this.httpOptions);
  }

  submitCashRequest(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/request`, msgData, this.httpOptions);
  }

  cashReturnList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/returnlist`, msgData, this.httpOptions);
  }

  cashReturn(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/return`, msgData, this.httpOptions);
  }
  
  cashRequestDetail(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/detail`, msgData, this.httpOptions);
  }

  cashRequestType(msgData: any, type: string){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/` + type, msgData, this.httpOptions);
  }

  cashEntryList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/entrylist`, msgData, this.httpOptions);
  }

  cashEntryDetailList(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/entrydetail`, msgData, this.httpOptions);
  }

  transactionCategoryList(){
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/gettransactioncategory`, this.httpOptions);
  }

  cashEntryForm(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/entry`, msgData, this.httpOptions);
  }

  cashEntryAccountInfo(){
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/accountinfo`, this.httpOptions);
  }

  cashTransactionCategory(){
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + `cashtransfer/gettransactioncategory`, this.httpOptions);
  }

  cashRequestBranchInfo(msgData: any){
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/getbranchterminalinfo`, msgData, this.httpOptions);
  }

  getBranchList() :  any{
    return this.http.get<BaseResponse<any>>(
      this.baseAPIUrl + 'adminusers/branchlist', this.httpOptions
    );
  }

  getTerminalList(msgData: any) :  any{
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + 'adminusers/terminallist', msgData, this.httpOptions
    );
  }
  // cashReconcile(msgData: any){
  //   return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/reconcile`, msgData, this.httpOptions);
  // }

  // cashClosingBalance(msgData: any){
  //   return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `cashrequest/close`, msgData, this.httpOptions);
  // }
}
